<template>
  <div class="positive-negative-bar-chart-table">
    <!-- TODO Revive, fix, and add themes to this filter -->
    <!-- <div class="positive-negative-bar-chart-table__options"
      v-if="value.meta.hasPreProcessedText && value.meta.includeSentiments == 'include' && value.meta.isSentimentMode">
      <div class="select-wrapper" style="margin-right: 0.5rem">
        <label class="sr-only" :for="`${value.uuid}-select`">
          Filter rows
        </label>
        <select class="select" :id="`${value.uuid}-select`" v-model="selectValue">
          <option value="" selected>Select Rows</option>
          <option value="all">all</option>
          <option v-for="filter in value.meta.table.filterByLabel" :key="filter" :value="filter">
            {{ filter }}
          </option>
        </select>
      </div>
      <button @click="onClickFilter"> Filter </button>
      <button @click="onClickResetSelection"> Reset selection </button>
      <span>{{ selected.length }} selected</span>
    </div> -->
    <table class="document-node__alt-table" :aria-labelledby="`${value.uuid}-chart-title`">
      <thead>
        <tr>
          <td></td>

          <th scope="col" :id="`${value.uuid}-col1`">
            {{ value.meta.table.columns[0] }}
          </th>

          <!-- Sentiment-mode columns -->
          <template
            v-if="
              value.meta.hasPreProcessedText &&
              value.meta.includeSentiments === 'include' &&
              value.meta.isSentimentMode
            "
          >
            <th v-for="col in value.meta.table.columns.slice(1)" :key="col" scope="col">
              {{ col }}
            </th>
          </template>

          <!-- Normal columns -->
          <template v-else>
            <th v-for="col in filteredColHeaders" :key="col" scope="col">
              {{ col }}
            </th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in data__ALL" :key="`table-row-${index}`">
          <td></td>

          <th scope="row" :id="`${value.uuid}-row-${index}`">
            {{ row.responseID }}
          </th>

          <!-- Sentiment-mode cells -->
          <template
            v-if="
              value.meta.hasPreProcessedText &&
              value.meta.includeSentiments === 'include' &&
              value.meta.isSentimentMode
            "
          >
            <td
              v-for="key in ['response', 'score', 'label', 'themes']"
              :key="`table-row-${index}-cell-${key}`"
            >
              {{ row[key] }}
            </td>
          </template>

          <!-- Normal cells -->
          <template v-else>
            <td v-for="key in ['response', 'themes']" :key="`table-row-${index}-cell-${key}`">
              {{ row[key] }}
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import PigeonDocNodeModel from '../../models/PigeonDocNodeModel';

export default {
  name: 'PositiveNegativeBarCharTable',
  props: {
    value: PigeonDocNodeModel,
  },
  data() {
    return {
      selected: [],
      selectValue: '',
    };
  },
  computed: {
    data__ALL() {
      return this.value.content.data__ALL || this.value.content.data;
    },
    filteredColHeaders() {
      let colHeaders = [];
      const oldColHeaders = this.value.meta.table.columns.slice(1);
      for (let i = 0; i < oldColHeaders.length; i++) {
        if (
          oldColHeaders[i].toLowerCase() !== 'score' &&
          oldColHeaders[i].toLowerCase() !== 'sentiment'
        ) {
          colHeaders.push(oldColHeaders[i]);
        }
      }
      return colHeaders;
    },
  },
  methods: {
    onChangeSelectValue() {
      if (this.selectValue === 'all') {
        this.selected = this.data__ALL.map((data) => data.id);
      } else if (this.value.meta.table.filterByLabel.includes(this.selectValue)) {
        this.selected = this.data__ALL
          .filter((data) => data.label == this.selectValue)
          .map((d) => d.id);
      } else {
        this.selected = [];
      }
    },
    onClickFilter() {
      if (this.selected.length === 0) return;
      let selection = this.data__ALL.filter((data) => this.selected.includes(data.id));
      this.$emit('selection-changed', selection);
    },
    onClickResetSelection() {
      this.selectValue = '';
      this.$emit('reset-selection');
    },
  },
  watch: {
    selectValue() {
      this.onChangeSelectValue();
    },
  },
};
</script>

<style>
.positive-negative-bar-chart-table {
  height: 40vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.positive-negative-bar-chart-table__options {
  align-items: center;
  background: #fff;
  display: flex;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  position: sticky;
  top: 0;
  left: 0;
  width: calc(100% - 1px);
  z-index: 999;
}

.positive-negative-bar-chart-table__options button {
  background: #fff;
  border: 1px solid #cccccc;
  border-radius: 4px;
  margin: 0 0.5rem;
  padding: 0.25rem 0.5rem;
  font-size: 0.9rem;
}
</style>
